<template>
  <div class="building-statistics">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-number">{{ stats.totalBuildings || 0 }}</div>
        <div class="stat-label">Total Buildings</div>
      </div>
      
      <div class="stat-card">
        <div class="stat-number">{{ stats.thisMonth || 0 }}</div>
        <div class="stat-label">This Month</div>
      </div>
      
      <div class="stat-card">
        <div class="stat-number">{{ stats.last30Days || 0 }}</div>
        <div class="stat-label">Last 30 Days</div>
      </div>
      
      <div class="stat-card" v-if="stats.last7Days !== undefined">
        <div class="stat-number">{{ stats.last7Days || 0 }}</div>
        <div class="stat-label">Last 7 Days</div>
      </div>
    </div>

    <div class="stats-details mt-4" v-if="stats.buildingsByType && stats.buildingsByType.length">
      <h5>Buildings by Type</h5>
      <div class="type-stats">
        <div 
          v-for="type in stats.buildingsByType" 
          :key="type._id"
          class="type-stat"
        >
          <span class="type-name">{{ type._id || 'Unknown' }}</span>
          <span class="type-count">{{ type.count }}</span>
        </div>
      </div>
    </div>

    <div class="stats-details mt-4" v-if="showCreatorStats && stats.buildingsByCreator && stats.buildingsByCreator.length">
      <h5>Top Creators</h5>
      <div class="creator-stats">
        <div 
          v-for="creator in stats.buildingsByCreator.slice(0, 5)" 
          :key="creator._id"
          class="creator-stat"
        >
          <span class="creator-name">{{ creator._id || 'Unknown' }}</span>
          <span class="creator-count">{{ creator.count }}</span>
        </div>
      </div>
    </div>

    <div class="stats-details mt-4" v-if="stats.avgDimensions">
      <h5>Average Dimensions</h5>
      <div class="dimension-stats">
        <div class="dimension-stat">
          <span class="dimension-label">Width:</span>
          <span class="dimension-value">{{ Math.round(stats.avgDimensions.avgWidth || 0) }}ft</span>
        </div>
        <div class="dimension-stat">
          <span class="dimension-label">Length:</span>
          <span class="dimension-value">{{ Math.round(stats.avgDimensions.avgLength || 0) }}ft</span>
        </div>
        <div class="dimension-stat">
          <span class="dimension-label">Height:</span>
          <span class="dimension-value">{{ Math.round(stats.avgDimensions.avgHeight || 0) }}ft</span>
        </div>
        <div class="dimension-stat">
          <span class="dimension-label">Square Feet:</span>
          <span class="dimension-value">{{ Math.round(stats.avgDimensions.avgSqft || 0) }}sqft</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuildingStatistics',
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({})
    },
    showCreatorStats: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.building-statistics {
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .stat-card {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem 1rem;
    text-align: center;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    }

    .stat-number {
      font-size: 2rem;
      font-weight: bold;
      color: #007bff;
      margin-bottom: 0.5rem;
    }

    .stat-label {
      font-size: 0.9rem;
      color: #6c757d;
      font-weight: 500;
    }
  }

  .stats-details {
    h5 {
      color: #495057;
      margin-bottom: 1rem;
      font-weight: 600;
    }
  }

  .type-stats, .creator-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.5rem;
  }

  .type-stat, .creator-stat {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem;
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 4px;

    .type-name, .creator-name {
      font-weight: 500;
      color: #495057;
    }

    .type-count, .creator-count {
      font-weight: bold;
      color: #007bff;
      background: #e3f2fd;
      padding: 0.25rem 0.5rem;
      border-radius: 12px;
      font-size: 0.85rem;
    }
  }

  .dimension-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
  }

  .dimension-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 4px;

    .dimension-label {
      font-size: 0.85rem;
      color: #6c757d;
      margin-bottom: 0.25rem;
    }

    .dimension-value {
      font-weight: bold;
      color: #495057;
      font-size: 1.1rem;
    }
  }
}
</style>
